import { render, staticRenderFns } from "./CategoryProductsCard.vue?vue&type=template&id=06114f9f&scoped=true&"
import script from "./CategoryProductsCard.vue?vue&type=script&lang=js&"
export * from "./CategoryProductsCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProductsCard.vue?vue&type=style&index=0&id=06114f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06114f9f",
  null
  
)

export default component.exports